/**
 * Premium Dynamic Grid Handlers
 */
class PremiumBlogSliderSection {
  constructor(element) {
    this.sectionContainer = element;
    this.sectionId = element.getAttribute('data-section-id');
    this.init();
  }

  init() {
    if (!this.sectionContainer) return;
    this.sectionContainer.setAttribute('data-slider-ready', 'true');
    console.log(`Grid Module [${this.sectionId}] safely initialized.`);
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const mountBlogGrids = () => {
    const modules = document.querySelectorAll('.premium-blog-slider:not([data-slider-ready="true"])');
    modules.forEach(instance => new PremiumBlogSliderSection(instance));
  };

  mountBlogGrids();

  // Theme Customizer live reload trigger framework binding
  document.addEventListener('shopify:section:load', (event) => {
    const freshInstance = event.target.querySelector('.premium-blog-slider');
    if (freshInstance) {
      new PremiumBlogSliderSection(freshInstance);
    }
  });
});